/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

module.exports.formatUrl = (base, route, params) => {
    let url = base.concat(route);
    for (const prop in params) {
        if (params.hasOwnProperty(prop)){
            url = url.replace(':'.concat(prop), params[prop]);
        }
    }
    if (params && params.queryParams) {
        url = addQueryParameters(url, params.queryParams);
    }

    return url;
};

function addQueryParameters (url, queryParams) {
    for (const prop in queryParams) {
        if (queryParams[prop] === undefined) {
            continue;
        }
        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }
        url += prop.concat('=');
        if (Array.isArray(queryParams[prop])) {
            url += queryParams[prop].join('&'.concat(prop).concat('='));
        } else {
            url += queryParams[prop];
        }
    }

    return url;
}


// WEBPACK FOOTER //
// ./src/_helpers/url.format.helper.js